const mediaItems = [
  {
    title: '《唐朝诡事录之西行》精彩片段',
    duration: '45:32',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20detective%20drama%20scene%20with%20warm%20lantern%20light%20and%20deep%20shadows%2C%20atmospheric%20Tang%20dynasty%20setting%20with%20fog%20and%20candlelight%2C%20cinematic%20thriller%20aesthetic%20with%20rich%20amber%20and%20crimson%20tones%2C%20simple%20dark%20background&width=800&height=500&seq=media-1-51video&orientation=landscape',
  },
  {
    title: '《歌手2025》华晨宇炸裂现场',
    duration: '12:18',
    views: '256万',
    img: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20spotlight%20and%20colorful%20stage%20lighting%2C%20energetic%20music%20performance%20atmosphere%2C%20warm%20golden%20and%20purple%20stage%20lights%20on%20dark%20background%2C%20cinematic%20live%20show%20photography%2C%20simple%20stage%20setting&width=800&height=500&seq=media-2-51video&orientation=landscape',
  },
  {
    title: '《奔跑吧》新一期爆笑合集',
    duration: '28:45',
    views: '189万',
    img: 'https://readdy.ai/api/search-image?query=Bright%20and%20lively%20outdoor%20variety%20show%20scene%20with%20warm%20sunlight%2C%20fun%20and%20playful%20atmosphere%20with%20vibrant%20colors%2C%20natural%20golden%20hour%20lighting%20on%20green%20field%2C%20entertaining%20reality%20show%20aesthetic%2C%20simple%20outdoor%20background&width=800&height=500&seq=media-3-51video&orientation=landscape',
  },
  {
    title: '《异人之下2》超燃打斗混剪',
    duration: '08:56',
    views: '342万',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20martial%20arts%20fantasy%20action%20scene%20with%20dramatic%20lighting%20and%20motion%20blur%2C%20intense%20battle%20atmosphere%20with%20warm%20golden%20energy%20effects%2C%20cinematic%20superhero%20aesthetic%20with%20rich%20crimson%20and%20amber%20tones%2C%20dark%20dramatic%20background&width=800&height=500&seq=media-4-51video&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热门视频</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">精彩片段与花絮集锦，感受影视作品的高光时刻</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-xs whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <div className="flex items-center gap-1 mt-1.5 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次播放</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}